module.exports = __webpack_public_path__ + "img/toutiao.5b282e7b.png";